import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/App/App.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAzureConfig"] */ "/app/src/services/azureConfiguration/useAzureConfigHook.ts");
